import React from "react";
import Table from "src/components/Table";
import { Asset } from "src/types";
import { ASSETS_TABLE_HEADERS } from "../constants";
import DataTable from "src/components/Table";
import TableRow from "src/components/Table/TableRow";
import styled from "styled-components";
import { StyledTableCell } from "src/components/Table/TableCell";

export interface AssetsTableProps {
  data: Asset[];
  onRowClick: (asset: Asset) => void;
}

export const AssetsTable = ({ data, onRowClick }: AssetsTableProps) => {
  const formatDate = (dateString?: string) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      return date.getFullYear().toString();
    } catch {
      return dateString;
    }
  };

  return (
    // <Table headers={ASSETS_TABLE_HEADERS}>
    //   {data.map((asset: Asset) => (
    //     <tr key={asset.id}>
    //       {/* <td>{asset.siteid || asset.stationId || 'N/A'}</td> */}
    //       <td>{asset.location || asset.roomLocation || "N/A"}</td>
    //       {/* <td>{asset.stationName || 'N/A'}</td> */}
    //       <td>{asset.location || asset.location || "N/A"}</td>
    //       <td>{asset.assetnum || asset.assetCode || "N/A"}</td>
    //       <td>{asset.description || "N/A"}</td>
    //       <td>{asset.assettype_description || asset.assettype || asset.category || "N/A"}</td>
    //       <td>{asset.subCategory || "N/A"}</td>
    //       <td>{asset.location || asset.roomLocation || "N/A"}</td>
    //       <td>{formatDate(asset.installdate) || asset.installYear || "N/A"}</td>
    //       <td>{asset.status_description || asset.status || "N/A"}</td>
    //     </tr>
    //   ))}
    // </Table>
    <DataTable headers={ASSETS_TABLE_HEADERS}>
      <>
        {data.map((asset: Asset) => (
          <TableRow onClick={() => onRowClick(asset)} $clickable key={asset.id}>
            <StyledCell>{asset.location_description || "N/A"}</StyledCell>
            {/* <StyledCell>{asset.stationName || "N/A"}</StyledCell> */}
            <StyledCell>{asset.assetnum || asset.assetCode || "N/A"}</StyledCell>
            <StyledCell>{asset.description || "N/A"}</StyledCell>
            <StyledCell>{asset.assettype_description || asset.assettype || asset.category || "N/A"}</StyledCell>
            {/* <StyledCell>{asset.subCategory || "N/A"}</StyledCell> */}
            <StyledCell>{asset.location || "N/A"}</StyledCell>
            <StyledCell>{formatDate(asset.installdate) || asset.installYear || "N/A"}</StyledCell>
            <StyledCell>{asset.status_description || asset.status || "N/A"}</StyledCell>
          </TableRow>
        ))}
      </>
    </DataTable>
  );
};

const StyledCell = styled(StyledTableCell)`
  height: 50px;
  box-sizing: content-box;
  padding: 10px;
`;
